import script from "./AppFooterBusinessHours.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppFooterBusinessHours.vue?vue&type=script&setup=true&lang=ts"

import "./AppFooterBusinessHours.vue?vue&type=style&index=0&id=7170c4cc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7170c4cc"]])

export default __exports__